<div class="px-4 sm:px-6 lg:px-8">
    <!-- Header Section -->
    <div class="sticky top-16 z-10 bg-white w-screen md:w-auto -mx-4 md:mx-0 shadow md:shadow-none">
      <div class="mx-auto max-w-7xl">
        <div class="px-4 sm:px-6 lg:px-8 py-4">
          <div class="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:justify-between sm:items-center">
            <h1 class="text-2xl font-semibold text-gray-900">Vendor Work</h1>
          
          <!-- Action Buttons -->
          <div class="grid grid-cols-2 gap-3 sm:flex sm:space-x-4">
            <button
            (click)="openInviteVendor()"
            class="inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
           >
            <svg 
              class="h-5 w-5 sm:mr-2" 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                stroke-linecap="round" 
                stroke-linejoin="round" 
                stroke-width="2" 
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              />
            </svg>
            <span class="hidden sm:inline">Invite Vendor</span>
           </button>
            
            <button
             (click)="openCreateVendorTask()"
             class="inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
             <svg 
               class="h-5 w-5 sm:mr-2" 
               xmlns="http://www.w3.org/2000/svg" 
               fill="none" 
               viewBox="0 0 24 24" 
               stroke="currentColor"
             >
               <path 
                 stroke-linecap="round" 
                 stroke-linejoin="round" 
                 stroke-width="2" 
                 d="M12 4v16m8-8H4"
               />
             </svg>
             <span class="hidden sm:inline">Create Sublet</span>
            </button>
          </div>
        </div>
        </div>
  
        <div class="hidden md:block border-b border-gray-200"></div>
        
        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex justify-center items-center py-8">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
  
        <!-- Table -->
        <div class="mt-8 flow-root">
          <div *ngIf="!isLoading" >
            <div class="align-middle">
              <div class="hidden md:block overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th scope="col" class="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-6 w-1/3">Vendor</th>
                      <!-- Hidden on mobile -->
                      <th scope="col" class="hidden md:table-cell px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Request</th>
                      <th scope="col" class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1/4">RO Number</th>
                      <!-- Hidden on mobile -->
                      <th scope="col" class="hidden md:table-cell px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Sent Date</th>
                      <th scope="col" class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Status</th>
                      <th scope="col" class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">Actions</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <tr *ngFor="let task of vendorTasks$ | async" (click)="viewTask(task)" class="hover:bg-gray-50 cursor-pointer transition-colors duration-150">
                      <td class="py-4 pl-4 pr-3 text-sm sm:pl-6">
                        <div class="flex flex-col items-center">
                          <span class="font-medium text-gray-900 break-words">{{task.tenants[0].name}}</span>
                          <span class="text-gray-500 break-words ">{{task.tenants[0].phoneNumber}}</span>
                        </div>
                      </td>
                      <!-- Hidden on mobile -->
                      <td class="hidden md:table-cell text-center whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                          {{ task.servicesOffered }}
                        </span>
                      </td>
                      <td class="px-3 py-4 text-sm text-gray-500 break-words text-center">{{task.roNumber}}</td>
                      <!-- Hidden on mobile -->
                      <td class="hidden md:table-cell px-3 py-4 text-sm text-gray-500 text-center">
                        {{task.createdAt | date:'MM/dd/yyyy'}}
                      </td>
                      <td class="px-3 py-4 text-sm text-center">
                        <span class="whitespace-nowrap inline-flex rounded-md px-2 py-1 text-xs font-semibold leading-5"
                          [ngClass]="{
                            'bg-green-50 text-green-800 ring-1 ring-inset ring-green-600/20': task.taskCompleted === true,
                            'bg-yellow-50 text-yellow-800 ring-1 ring-inset ring-yellow-600/20': task.taskCompleted === false,
                          }">
                          {{task.taskCompleted ? 'Completed' : 'In Progress'}}
                        </span>
                      </td>
                      <td class="px-3 py-4 text-sm text-center">
                        <button (click)="viewTask(task)" 
                                class="inline-flex items-center text-gray-500 hover:text-gray-700">
                          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                          </svg>
                          <span class="sr-only">View Details</span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
  
         <!-- Mobile Cards (hidden on desktop) -->
        <div class="md:hidden space-y-4">
          <div *ngFor="let task of vendorTasks$ | async" 
              class="bg-white rounded-lg shadow p-4 border border-gray-200">
            <!-- Vendor Info -->
            <div class="mb-3">
              <h3 class="font-medium text-gray-900">{{task.tenants[0].name}}</h3>
              <p class="text-sm text-gray-500">{{task.tenants[0].phoneNumber}}</p>
            </div>
  
            <!-- Task Details -->
            <div class="space-y-2">
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-500">RO Number:</span>
                <span class="text-sm font-medium text-gray-900">{{task.roNumber}}</span>
              </div>
  
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-500">Request:</span>
                <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                  {{task.servicesOffered}}
                </span>
              </div>
  
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-500">Date:</span>
                <span class="text-sm text-gray-900">{{task.createdAt | date:'MM/dd/yyyy'}}</span>
              </div>
  
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-500">Status:</span>
                <span class="whitespace-nowrap inline-flex rounded-md px-2 py-1 text-xs font-semibold leading-5"
                  [ngClass]="{
                    'bg-green-50 text-green-800 ring-1 ring-inset ring-green-600/20': task.taskCompleted === true,
                    'bg-yellow-50 text-yellow-800 ring-1 ring-inset ring-yellow-600/20': task.taskCompleted === false
                  }">
                  {{task.taskCompleted ? 'Completed' : 'In Progress'}}
                </span>
              </div>
            </div>
  
            <!-- Action Buttons -->
            <div class="mt-4">
              <button (click)="viewTask(task)" 
                class="w-full text-sm font-semibold py-2 rounded-md bg-green-50 text-green-800 ring-1 ring-inset ring-green-600/20 hover:bg-green-100 transition-colors duration-200">
                View
              </button>
            </div>
          </div>
        </div>
  
        <!-- Dark Overlay -->
        <div *ngIf="isCreatePanelOpen" 
          class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          style="z-index: 40;">
        </div>
  
        <div *ngIf="isCreatePanelOpen" @slideInOut 
          class="fixed right-0 w-full md:w-2/3 bg-white shadow-xl z-50 transform transition-transform overflow-hidden" 
          [ngClass]="{'-translate-x-full': !isCreatePanelOpen, 'translate-x-0': isCreatePanelOpen}"
          style="top: 64px; bottom: 0;"
        >
            <lib-vendor-associate
             [taskData]="selectedTask"
             (slideOutToggled)="closeCreatePanel()">
            </lib-vendor-associate>   
      </div>
  
  
      <div
    *ngIf="isInviteVendorModalVisible"
    class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
  >
    <div class="bg-white w-full md:w-1/2 lg:w-1/3 rounded-lg shadow-lg p-6">
      <!-- Modal Header -->
      <div class="flex items-center justify-between mb-4 border-b pb-2">
        <h2 class="text-xl font-semibold text-gray-900">Invite A Vendor</h2>
        <button
          class="text-gray-500 hover:text-gray-700 focus:outline-none"
          (click)="closeInviteVendorModal()"
        >
          ✕
        </button>
      </div>
  
      <!-- Modal Content -->
      <form [formGroup]="inviteVendorForm" (ngSubmit)="submitInviteVendor()">
        <!-- Vendor Category Dropdown -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Vendor Category</label>
          <select
          formControlName="vendorCategory"
          class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
          <option value="">Select a category</option>
          <option *ngFor="let category of vendorCategories" [value]="category.value">
              {{category.label}}
          </option>
          </select>
          <div *ngIf="inviteVendorForm.get('vendorCategory')?.invalid && inviteVendorForm.get('vendorCategory')?.touched" 
               class="text-red-500 text-sm mt-1">
            Category is required
          </div>
      </div>
        <!-- Contact Name -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Contact Name <span class="text-red-500">*</span></label>
          <input
            formControlName="contactName"
            type="text"
            placeholder="Enter contact name"
            class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
          />
          <div *ngIf="inviteVendorForm.get('contactName')?.invalid && inviteVendorForm.get('contactName')?.touched" class="text-red-500 text-sm mt-1">
            Contact name is required.
          </div>
        </div>
  
        <!-- Vendor Name -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Vendor Name</label>
          <input
            formControlName="vendorName"
            type="text"
            placeholder="Enter vendor name"
            class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
          />
        </div>
  
        <!-- Phone Number (Required) -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Phone Number <span class="text-red-500">*</span></label>
          <input
            formControlName="phoneNumber"
            type="tel"
            placeholder="Enter phone number"
            class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
          />
          <div *ngIf="inviteVendorForm.get('phoneNumber')?.invalid && inviteVendorForm.get('phoneNumber')?.touched" class="text-red-500 text-sm mt-1">
            Phone number is required.
          </div>
        </div>
  
        <!-- Email Address -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
          <input
            formControlName="emailAddress"
            type="email"
            placeholder="Enter email address"
            class="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500"
          />
        </div>
  
        <!-- Modal Actions -->
        <div class="flex justify-end space-x-2">
          <button
            type="button"
            class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none"
            (click)="closeInviteVendorModal()"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            [disabled]="inviteVendorForm.invalid"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
      
      <!-- </div> -->
    </div>
  